import { useCallback, useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player/file";
import { useLocation } from "react-router";
import { api_getVideoSignedURL } from "../API/axios";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import Loading from "../Components/Loading";

const parseStartTime = (timestr) => {
  console.log(timestr)
  if (!timestr) return 0;
  let hr, min, sec
  hr = parseInt(timestr.slice(0, 2))
  min = parseInt(timestr.slice(3, 5))
  sec = parseInt(timestr.slice(6, 8))

  return hr * 3600 + min * 60 + sec
}

export const Video = () => {
  const [loading, setLoading] = useState(false)
  const [inited, setInited] = useState(false)
  const [signed_url, setSignedURL] = useState("")
  const location = useLocation()
  const video_url = location.state.vpath
  // localStorage.getItem('video_signed_url')
  const start_time = parseStartTime(localStorage.getItem('video_start_timecode'))
  // console.log(video_url, start_time)
  const playerRef = useRef(null)

  const handleOnReady = () => {
    if (!inited) {
      console.log("ready!")
      playerRef.current.seekTo(start_time, 'seconds')
      setInited(true)
    }
  }

  const handleOnKeyDown = (e) => {
    let cur = playerRef.current.getCurrentTime()
    if (e.key === ',') playerRef.current.seekTo(cur - 1/30, 'seconds')
    if (e.key === '.') playerRef.current.seekTo(cur + 1/30, 'seconds')
  }

  useEffect(() => {
    window.addEventListener("keydown", handleOnKeyDown)
    return () => {
      window.removeEventListener("keydown", handleOnKeyDown)
    }
  }, [])

  return (
    <>
      <Loading visible={loading} />
      <Header />
        <div className="wrapper">
          <div className="video-box" style={{ height: '50vw', display:'flex', alignItems: 'center', justifyContent: 'center'}}>
            <ReactPlayer ref={playerRef} url={video_url} playing controls onError={(e, ele) => {console.log(e, ele)}} onReady={handleOnReady} />
          </div>
        </div>
      <Footer />
    </>
  )
}